module.exports = __webpack_public_path__ + "media/site/images/icons/managing-icon-adef98e27f9901486043e892d9dac9ab.svg";